// Per-brand <head> meta injection for GEO / social attribution.
//
// The built bundle is SHARED across domains (mgv.gallery + openbadge.me serve
// the same /home/www/site/current docroot), so the static index.html is always
// mgv-branded: its <title>, <meta description>, <link canonical>, favicon and
// (absent) og:/twitter: tags describe MGV Gallery. For any non-mgv brand this
// misattributes the domain to MGV Gallery and gives social previews nothing to
// show. This overrides canonical/og/twitter/favicon at runtime from `brand`, so
// each domain is attributed correctly by crawlers and link unfurlers.
import brand from '../config/brand';
import { getOrganizationJsonLd } from './geo';

const BRAND_IMAGES = {
  mgv: 'https://www.mgv.gallery/logo192.png',
  openbadge: 'https://openbadge.me/openbadge-badge.svg?v=11',
  chefkunming: 'https://chefkunming.com/logo192.png',
  visitkunming: 'https://visit-kunming.com/logo192.png',
};

export function applyBrandMeta(b = brand) {
  if (typeof document === 'undefined') return;
  const origin = b.origin && b.origin.startsWith('http') ? b.origin : 'https://www.mgv.gallery';
  const org = getOrganizationJsonLd(b);
  const image = BRAND_IMAGES[b.key] || org.logo || '';
  const description = org.description || '';

  const setMeta = (selector, attr, key, value) => {
    if (!value) return;
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', value);
  };
  const setLink = (rel, href) => {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
      el = document.createElement('link');
      el.rel = rel;
      document.head.appendChild(el);
    }
    el.setAttribute('href', href);
  };

  document.title = b.siteName;
  setLink('canonical', `${origin}/`);
  setMeta('meta[property="og:locale"]', 'property', 'og:locale', 'en_US');
  setMeta('meta[property="og:locale:alternate"]', 'property', 'og:locale:alternate', 'zh_CN');
  setMeta('meta[property="og:title"]', 'property', 'og:title', b.siteName);
  setMeta('meta[property="og:description"]', 'property', 'og:description', description);
  setMeta('meta[property="og:image"]', 'property', 'og:image', image);
  setMeta('meta[property="og:image:alt"]', 'property', 'og:image:alt', `${b.siteName} logo`);
  setMeta('meta[property="og:site_name"]', 'property', 'og:site_name', b.siteName);
  setMeta('meta[property="og:type"]', 'property', 'og:type', 'website');
  setMeta('meta[property="og:url"]', 'property', 'og:url', `${origin}/`);
  setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary');
  setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', b.siteName);
  setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description);
  setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', image);
  setMeta('meta[name="twitter:image:alt"]', 'name', 'twitter:image:alt', `${b.siteName} logo`);

  // openbadge.me gets its own golden-yellow badge favicon (the shared docroot
  // otherwise serves mgv's framed emblem).
  if (b.key === 'openbadge') {
    setLink('icon', '/openbadge-badge.svg?v=11');
    setLink('apple-touch-icon', '/openbadge-badge.svg?v=11');
  }
}

export default applyBrandMeta;
